import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../hooks/useAuth';
import ChatThread from '../../components/messaging/ChatThread';
import './Messages.css';

export default function Messages() {
  const { user } = useAuth();
  const [client, setClient] = useState(null);
  const [practitionerName, setPractitionerName] = useState('your practitioner');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) loadData();
  }, [user]);

  async function loadData() {
    setLoading(true);

    // Get client record
    const { data: clientData } = await supabase
      .from('clients')
      .select('*, practitioners(id, name, practice_name)')
      .eq('auth_user_id', user.id)
      .single();

    if (clientData) {
      setClient(clientData);
      const prac = clientData.practitioners;
      if (prac) {
        setPractitionerName(prac.practice_name || prac.name || 'your practitioner');
      }
    }

    setLoading(false);
  }

  if (loading) {
    return (
      <div className="screen container">
        <div style={{ textAlign: 'center', padding: '80px 0', color: 'var(--color-text-muted)' }}>
          Loading messages...
        </div>
      </div>
    );
  }

  if (!client) {
    return (
      <div className="screen container">
        <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--color-text-secondary)' }}>
          <p>No practitioner connected yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="screen container client-messages-screen">
      <h1 className="client-msg-title">Messages</h1>
      <p className="client-msg-sub">{practitionerName}</p>

      <div className="client-msg-thread">
        <ChatThread
          clientId={client.id}
          practitionerId={client.practitioner_id}
          recipientName={practitionerName}
        />
      </div>
    </div>
  );
}
